import NavBar from '../../components/NavBar/NavBar'
import Footer from '../../components/Footer/Footer'

export default function Main() {
   
    return (

        <div className=''>
            <NavBar/>
            <img style={{width: '100vw', objectFit: 'cover', height: '80vh'}} src="https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Paintings/Last_Supper.jpg" alt='Imagem Ultima-Ceia' />
            <Footer/>
        </div>
                
    )
}